import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Moment } from 'moment';
import 'moment/locale/de';
import 'moment/locale/fr';
import { FutureOrderConfirmAction } from '../../enums/FutureOrderConfirmAction';
import { sleep } from '../../../smoothr-web-app-core/utils/utils';

@Component({
	selector: 'app-future-order-confirm-modal',
	templateUrl: './future-order-confirm-modal.component.html',
	styleUrls: ['./future-order-confirm-modal.component.scss'],
})
export class FutureOrderConfirmModalComponent {
	@Input() orderAt: Moment;
	action = FutureOrderConfirmAction;

	constructor(
		private modalCtrl: ModalController,
		private translate: TranslateService
	) {}

	static async show(modalCtrl: ModalController, orderAt: Moment): Promise<FutureOrderConfirmAction> {
		const modal = await modalCtrl.create({
			component: FutureOrderConfirmModalComponent,
			cssClass: 'auto-height future-order-confirm-modal',
			componentProps: {
				orderAt,
			},
			backdropDismiss: true,
			showBackdrop: true,
		});
		await modal.present();
		const result = (await modal.onDidDismiss()).data;
		await sleep(200);
		return result ?? null;
	}

	// Full weekday name for the headline, e.g. "Samstag".
	get weekday(): string {
		return this.localizedOrderAt.format('dddd');
	}

	// Short weekday plus date for the subline, e.g. "Sa. 03.02.".
	get dateText(): string {
		return this.localizedOrderAt.format('dd[.] DD.MM.');
	}

	get timeText(): string {
		return this.localizedOrderAt.format('HH:mm');
	}

	async dismiss(action: FutureOrderConfirmAction) {
		await this.modalCtrl.dismiss(action);
	}

	private get localizedOrderAt(): Moment {
		return moment(this.orderAt).locale(this.translate.currentLang ?? 'de');
	}
}
